import React from "react";
import InlineEdit from "@atlaskit/inline-edit";
import { ExtendedFieldProps } from "@atlaskit/inline-edit/dist/types/types";
import { useTheme } from "@mui/material/styles";
import { IExtendedL3 } from "../../services/NetworkApi";

import { useInputHandler } from "./useInputHandler";
import { TextField } from "../TextField";
import { Box } from "../../UI/Box";
import useAuth from "../../routes/login/AuthContext";

export interface IProps {
  value: number;
  isDisabled?: boolean;
  l3Id: number;
  l2Id: number;
  updateData: React.Dispatch<React.SetStateAction<IExtendedL3[]>>;
}

const readView = (value: number) => () => {
  const theme = useTheme();

  return (
    <Box p={1.5} bgcolor={theme.palette.action.hover}>
      {value || "No Max"}
    </Box>
  );
};

const editView = (isDisabled: boolean) => ({
  errorMessage,
  ...fieldProps
}: ExtendedFieldProps<string>) => (
  <TextField {...fieldProps} autoFocus type="number" isDisabled={isDisabled} />
);

export const MaxNumberInput: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { handleOnBlur, value } = useInputHandler(props);
  return (
    !!props.isDisabled ? <TextField value={value} autoFocus type="number" isDisabled /> :
    <InlineEdit
      key={`${props.l2Id}-${props.l3Id}`}
      defaultValue={value}
      editView={editView(isSuperAdminRead())}
      readView={readView(value)}
      onConfirm={handleOnBlur}
      keepEditViewOpenOnBlur
    />
  );
};
